import React from 'react';
import { motion } from 'framer-motion';
import { Users } from 'lucide-react';

export const Soci: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6"
      >
        <Users className="w-10 h-10 text-primary" />
      </motion.div>
      <h2 className="text-2xl font-bold mb-2">Socio CpGev Bologna</h2>
      <p className="text-muted-foreground max-w-md">
        Questa pagina è attualmente in fase di sviluppo. Torna presto per vedere le nuove funzionalità!
      </p>
    </div>
  );
};
